import React from 'react'
import styled from 'styled-components'
import CardPayment from '../CheckoutPaymentSection/CardPayment'
import CreditTermPayment from '../CheckoutPaymentSection/CreditTermPayment'
import VendorsGovPayment from '../CheckoutPaymentSection/VendorsGovPayment'
import GeBizPayment from '../CheckoutPaymentSection/GeBizPayment'
import Carousel from '../Carousel'
import Text from '../Text'
import { CHECKOUT_PAYMENT_METHODS } from '../../utils/constants/general'
import _get from 'lodash/get'
import { getUserType } from '../../utils/userType'
import { get, headers, post } from '../../lib/fetch'
import CorpBillingPayment from '../CheckoutPaymentSection/CorpBillingPayment'

const PaymentMethodList = styled.ul`
  margin-bottom: 1rem;

  a {
    text-decoration: none;

    background-color: white;
    color: #1557bf;

    display: block;
    margin-right: 0.5rem;
    padding: 0.5rem 1rem;

    border-radius: 4px;
    border-color: #eaeaea;
  }

  li {
    display: inline-block;
    white-space: normal;
    vertical-align: top;
  }
`

const PaymentMethodItem = styled.button`
  display: inline-block;
  color: ${({ checked }) => (checked ? '#ffffff' : '#1557bf')};
  background-color: ${({ checked }) => (checked ? '#1557bf' : '#ffffff')};
  margin-right: 0.5rem;
  padding: 0.63rem 0.75rem;
  text-align: center;
  border-radius: 4px;
  font-size: 0.875rem;
  border: 1px solid #eaeaea;
  cursor: pointer;
  outline: none;
  overflow: hidden;
`

const PaymentContent = styled.div`
  color: #333;
`

class CheckoutPaymentSection extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tabValue:
        props.defaultB2BPaymentMethod || CHECKOUT_PAYMENT_METHODS.ONLINE.value,
      isAPIcalled: false,
      isTimeSlotChanged: props.timeSlotChanged,
    }
    this.getAddedAgencies = this.getAddedAgencies.bind(this)
    this.validateCorpBillingTimeSlot =
      this.validateCorpBillingTimeSlot.bind(this)
  }

  componentDidMount() {
    this.getAddedAgencies()
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.defaultB2BPaymentMethod !== this.props.defaultB2BPaymentMethod
    ) {
      this.setState({ tabValue: this.props.defaultB2BPaymentMethod })
    }
  }

  async getAddedAgencies() {
    if (getUserType() === 'B2B') {
      const url = 'corp-billings?status=APPROVED'
      const response = await get(url, {
        headers: headers(),
      })
      const agenciesList = _get(response, 'data.corpBillings')
      if (agenciesList) {
        this.setState({
          agenciesList,
        })
      }
    }
  }

  async validateCorpBillingTimeSlot() {
    if (
      getUserType() === 'B2B' &&
      this.props.expandCalled &&
      !this.state.isAPIcalled
    ) {
      this.setState({ isAPIcalled: true })
      const { values, organizationData, initialValues, user } = this.props
      if (!organizationData?.defaultStoreId) {
        return 0
      }

      const maxHandlingDays = {}
      const sellerItems = this.props?.sellersItems || []
      sellerItems.forEach(item => {
        if (item.sellerInfo.id !== null) {
          const items = item.items
          Object.keys(items).forEach(key => {
            const handlingDays = items[key]?.__server__handlingDays || 0
            if (
              !maxHandlingDays[item.sellerInfo.id] ||
              handlingDays > maxHandlingDays[item.sellerInfo.id]
            ) {
              maxHandlingDays[item.sellerInfo.id] = handlingDays
            }
          })
        } else {
          const items = item.items
          Object.keys(items).forEach(key => {
            const handlingDays = items[key]?.__server__handlingDays || 0
            if (
              !maxHandlingDays['fp'] ||
              handlingDays > maxHandlingDays['fp']
            ) {
              maxHandlingDays['fp'] = handlingDays
            }
          })
        }
      })

      const itemsPayload = []
      Object.keys(this.props.items || {}).forEach(id => {
        const item = this.props.items[id] || 0

        itemsPayload.push({
          id,
          isChecked: item.isChecked,
          q: item.q,
          t: item.t,
          reason: item.reason,
        })
      })

      const storeId =
        initialValues?.storeId?.toString() ||
        organizationData.defaultStoreId.toString()
      const cartBody = {
        storeId,
        address: {
          storeId,
          pincode: initialValues?.pincode,
        },
        isCheckerEnabled: true,
        isSellerTimeSlotEnabled: true,
        isSellerCheckerEnabled: true,
        isDirectFulfilmentEnabled: true,
        cart: { items: itemsPayload },
        orderType: getUserType() === 'B2B' ? 'B2B' : 'DELIVERY',
        preferredDate: values?.preferredDate,
        preferredSlotId: values?.preferredSlotId,
        customerId: user?.id.toString() || '',
        sellerTimeSlots: JSON.parse(values?.sellerTimeSlotsString || '[]'),
        payment: [{ paymentMode: CHECKOUT_PAYMENT_METHODS.CORPBILLING.value }],
        handlingDays: maxHandlingDays,
      }

      const response = await post('checkout', {
        headers: headers(),
        body: JSON.stringify(cartBody),
      })
        .catch(() => {
          return 0
        })
        .finally(() => {
          this.setState({ isAPIcalled: false, isTimeSlotChanged: false })
        })

      if (response && response.data && response.data.message === undefined) {
        return 1
      } else if (
        !response ||
        !response?.data ||
        (response && response.data && response.data.message !== null)
      ) {
        this.props.onCorpbillingTimeSlot(response.data?.sellersTimeSlots)
        return 0
      }
      return 1
    }
  }

  resetTabValue = () => {
    this.setState({
      tabValue:
        this.props.defaultB2BPaymentMethod ||
        CHECKOUT_PAYMENT_METHODS.ONLINE.value,
      isAPIcalled: false,
    })
  }
  resetAPICalled = () => {
    this.setState({ isAPIcalled: false })
  }

  render() {
    const {
      onChange,
      isUserCardChanged,
      defaultCard,
      isMemberShipFlowEnabled,
      b2bPaymentMethods,
      isGooglePayAvailable,
      isApplePayAvailable,
      cardServiceDown,
      googleServiceDown,
      appleServiceDown,
    } = this.props

    const onSelectPayment = (selectedCard, selectedMethod, isNewCard) => {
      let paymentMethod = CHECKOUT_PAYMENT_METHODS.ONLINE.value
      if (selectedMethod === 'google-pay') {
        paymentMethod = CHECKOUT_PAYMENT_METHODS.GOOGLE_PAY.value
      } else if (selectedMethod === 'apple-pay') {
        paymentMethod = CHECKOUT_PAYMENT_METHODS.APPLE_PAY.value
      }
      onChange({
        paymentMethod,
        paymentData: { selectedCard },
        isNewCard,
      })
    }

    if (!b2bPaymentMethods || b2bPaymentMethods.length === 0) {
      return (
        <CardPayment
          isUserCardChanged={isUserCardChanged}
          defaultCard={defaultCard}
          isMemberShipFlowEnabled={isMemberShipFlowEnabled}
          onSelect={onSelectPayment}
          isGooglePayAvailable={isGooglePayAvailable}
          isApplePayAvailable={isApplePayAvailable}
          cardServiceDown={cardServiceDown}
          googleServiceDown={googleServiceDown}
          appleServiceDown={appleServiceDown}
        />
      )
    }

    const { tabValue } = this.state || {}

    const values = JSON.parse(this.props?.values?.sellerTimeSlotsString || '[]')
    return (
      <>
        <PaymentMethodList>
          <Carousel
            infiniteScrolling
            selectedIndex={b2bPaymentMethods.indexOf(
              b2bPaymentMethods[tabValue]
            )}
          >
            {b2bPaymentMethods.map(key => (
              <li key={CHECKOUT_PAYMENT_METHODS[key].value}>
                <PaymentMethodItem
                  onClick={() =>
                    this.setState({
                      tabValue: CHECKOUT_PAYMENT_METHODS[key].value,
                      isAPIcalled: false,
                    })
                  }
                  data-testid={`tab-${key}`}
                  checked={CHECKOUT_PAYMENT_METHODS[key].value === tabValue}
                >
                  <Text weight="bold">
                    {CHECKOUT_PAYMENT_METHODS[key].text}
                  </Text>
                </PaymentMethodItem>
              </li>
            ))}
          </Carousel>
        </PaymentMethodList>
        <PaymentContent>
          {tabValue === CHECKOUT_PAYMENT_METHODS.ONLINE.value && (
            <CardPayment
              isUserCardChanged={isUserCardChanged}
              defaultCard={defaultCard}
              isMemberShipFlowEnabled={isMemberShipFlowEnabled}
              onSelect={onSelectPayment}
              isGooglePayAvailable={isGooglePayAvailable}
              isApplePayAvailable={isApplePayAvailable}
              cardServiceDown={cardServiceDown}
              googleServiceDown={googleServiceDown}
              appleServiceDown={appleServiceDown}
            />
          )}
          {tabValue === CHECKOUT_PAYMENT_METHODS.CORPBILLING.value &&
            getUserType() === 'B2B' && (
              <CorpBillingPayment
                values={values}
                resetTabValue={this.resetTabValue}
                resetAPICalled={this.resetAPICalled}
                refreshAgencyList={this.getAddedAgencies}
                agenciesList={this.state.agenciesList || []}
                validateTimeSlot={() => this.validateCorpBillingTimeSlot()}
                sellersTimeSlots={this.props.sellersTimeSlots}
                onSubmit={(formValues, purchaseReason) =>
                  onChange({
                    paymentMethod: CHECKOUT_PAYMENT_METHODS.CORPBILLING.value,
                    paymentData: formValues,
                    purchaseReason: purchaseReason,
                  })
                }
              />
            )}
          {tabValue === CHECKOUT_PAYMENT_METHODS.GEBIZ.value && (
            <GeBizPayment
              onSubmit={formValues =>
                onChange({
                  paymentMethod: CHECKOUT_PAYMENT_METHODS.GEBIZ.value,
                  paymentData: formValues,
                })
              }
            />
          )}
          {tabValue === CHECKOUT_PAYMENT_METHODS.EINVOICE.value && (
            <VendorsGovPayment
              onSubmit={formValues =>
                onChange({
                  paymentMethod: CHECKOUT_PAYMENT_METHODS.EINVOICE.value,
                  paymentData: formValues,
                })
              }
            />
          )}
          {tabValue === CHECKOUT_PAYMENT_METHODS.CREDITTERM.value && (
            <CreditTermPayment
              onSubmit={() =>
                onChange({
                  paymentMethod: CHECKOUT_PAYMENT_METHODS.CREDITTERM.value,
                })
              }
            />
          )}
        </PaymentContent>
      </>
    )
  }
}

export default CheckoutPaymentSection
